module.exports = __webpack_public_path__ + "img/brisbane-map.fa61acfe.jpg";